// extracted by mini-css-extract-plugin
module.exports = {"icon":"ToggleView_icon__6BAdy","button":"ToggleView_button__3txNu"};